// The country filter of an area picker, kept in the URL as ?country=XXX so a link, the browser's Back
// button and a return from the map all restore it. Without a valid country the picker shows every country.
// The check uses the registry only (never availability), so deep links work offline.
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { normalizeCountry } from '../config/countries';
import type { CountryCode } from '../config/countries';

export function useCountryFilter(): {
  /** The country the list is narrowed to; null shows all. */
  country: CountryCode | null;
  /** Narrow the list to a country, or pass null for all. Other query parameters are kept. */
  setCountry(c: CountryCode | null): void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const country = normalizeCountry(searchParams.get('country'));

  const setCountry = useCallback(
    (c: CountryCode | null) => {
      const next = new URLSearchParams(searchParams);
      if (c === null) next.delete('country');
      else next.set('country', c);
      setSearchParams(next);
    },
    [searchParams, setSearchParams],
  );

  return { country, setCountry };
}
